import type { HTMLAttributes, Ref } from 'react'
import type { VariantProps } from 'tailwind-variants'

import { cn } from '@gto/ui/cn'

import { dividerVariants } from './divider.styles'

type DividerVariantProps = VariantProps<typeof dividerVariants>

type DividerProps = Omit<HTMLAttributes<HTMLElement>, 'children' | 'role'> &
  DividerVariantProps & {
    /** Element to render. Defaults to 'div'. Use 'li' inside menus / lists. */
    as?: 'div' | 'li' | 'hr'
    /** Ref attached to the rendered element. */
    ref?: Ref<HTMLElement>
  }

const Divider = ({
  as: Tag = 'div',
  className,
  flexItem = false,
  inset = false,
  orientation = 'horizontal',
  ref,
  ...props
}: DividerProps) => {
  const ariaProps =
    Tag === 'hr'
      ? orientation === 'vertical'
        ? { 'aria-orientation': 'vertical' as const }
        : {}
      : { role: 'separator', 'aria-orientation': orientation }

  return (
    <Tag
      ref={ref as Ref<HTMLDivElement & HTMLLIElement & HTMLHRElement>}
      className={cn(dividerVariants({ orientation, flexItem, inset }), className)}
      {...ariaProps}
      {...props}
    />
  )
}

export { Divider }
export type { DividerProps }
